/**
 * Normalizes GET /api/core/ipos/{id}/faqs into [{ id, question, answer }].
 * Entries without both a question and an answer are dropped; text is plain (never HTML).
 */
const cleanText = (value) => (typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '');

export const mapIpoFaqs = (payload) => {
  const faqs = payload?.data?.faqs;
  if (!Array.isArray(faqs)) return [];
  return faqs
    .map((faq, index) => ({
      id: cleanText(faq?.id) || `faq-${index}`,
      question: cleanText(faq?.question),
      answer: cleanText(faq?.answer),
    }))
    .filter((faq) => faq.question && faq.answer);
};

export default mapIpoFaqs;
